import api from "../index";
import { apiUrl, constant } from "../../utils/constants";
import axios from "axios";
import { config } from "../../utils/helper"

export const AddDupontSchedule = (data) => api.post(`${constant.V1}${apiUrl.work_schedule}${apiUrl.dupont}/`, data)
export const AddFourOnFourOffSchedule = (data) => api.post(`${constant.V1}${apiUrl.work_schedule}${apiUrl.four_on_four_off}/`, data)
export const AddEoweoSchedule = (data) => api.post(`${constant.V1}${apiUrl.work_schedule}${apiUrl.eoweo}/`, data)
export const AddFourFiveSchedule = (data) => api.post(`${constant.V1}${apiUrl.work_schedule}${apiUrl.four_five}/`, data)
export const AddSevenOnSevenOffSchedule = (data) => api.post(`${constant.V1}${apiUrl.work_schedule}${apiUrl.seven_on_seven_off}/`, data)